import { Textarea } from '@/components/ui/textarea';
import { EventComment } from '@/features/event/types';
import { CommentListItem } from './CommentListItem';
import { useManagers } from '../api/getManagers';
import { convertUTCtoLocal } from '@/utils/convertUtcToLocal';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Label } from '@/features/label/components/label';
import { LabelGroup } from '@/features/label/types';
import { cn } from '@/utils';

interface CommentFieldProps {
  field: any;
  comments: EventComment[];
}

export function CommentField({ field, comments }: CommentFieldProps) {

  const { data: managers } = useManagers({});

  const historicalComments = comments?.map(comment => ({
    ...comment,
    author: managers?.find(manager => manager.managerId === comment.userId)?.username ?? '',
    inserted: convertUTCtoLocal(comment.inserted)
  }));

  const previewComments = historicalComments.slice(0, 5);
  const remainingComments = historicalComments.slice(5);

  return (
    <div className="space-y-4">
      {/* Current comment */}
      <Textarea
        className={cn('w-full')}
        onChange={e => field.onChange(e.target.value)}
      />

      {/* Comment history */}
      <div className="space-y-2">
        <Label
          name="comment_history_tab_title"
          groupName={LabelGroup.MANAGER_EVENT_HANDLING}
        />

        {historicalComments.length === 0 && (
          <div>
            <Label
              name="no_comment_history"
              groupName={LabelGroup.MANAGER_EVENT_HANDLING}
            />
          </div>
        )}

        {historicalComments.length > 0 && (
          <Collapsible className="space-y-2">
            {previewComments.map(comment => (
              <CommentListItem
                key={comment.eventLogId}
                comment={comment}
              />
            ))}

            <CollapsibleContent className="space-y-2">
              {remainingComments.map(comment => (
                <CommentListItem
                  key={comment.eventLogId}
                  comment={comment}
                />
              ))}
            </CollapsibleContent>

            {remainingComments.length > 0 && (
              <CollapsibleTrigger className="text-sm text-muted-foreground">
                <Label
                  name="show_all_comments"
                  groupName={LabelGroup.MANAGER_EVENT_HANDLING}
                />
              </CollapsibleTrigger>
            )}
          </Collapsible>
        )}
      </div>
    </div>
  );
}
